import React from 'react';
import PropTypes from 'prop-types';

const TipsAndHours = (props) =>{
    console.log(props);

    const {tipsData} = props;

    const setMarkup = (markup) => {
        return {
            __html: markup
        }
    }

    return(
        <div className="app-tour-tips">
            <h2>Tips & Hours</h2>
            <div dangerouslySetInnerHTML={setMarkup(tipsData)} />                
        </div>
    );
}

export default TipsAndHours;

TipsAndHours.defaultProps ={
    tipsData: 'testing'
}

TipsAndHours.propTypes = {
    tipsData: PropTypes.string.isRequired
}


// WEBPACK FOOTER //
// ./src/components/shared/TipsAndHours.js